import { render, staticRenderFns } from "./ImportTool.vue?vue&type=template&id=0534f4b3&scoped=true"
import script from "./ImportTool.vue?vue&type=script&lang=js"
export * from "./ImportTool.vue?vue&type=script&lang=js"
import style0 from "./ImportTool.vue?vue&type=style&index=0&id=0534f4b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0534f4b3",
  null
  
)

export default component.exports